import React from 'react';
import { useIntl } from 'react-intl';
import { translate } from '@smovilgps/optimus-intl';
import { Form, Input, Select } from 'antd';
import PropTypes from 'prop-types';
import { searchInString } from '../../utilities/util';

const ModelForm = ({ form, record, brands, modelSendTypes }) => {
	const intl = useIntl();

	const modelSendTypeOptions = modelSendTypes.map((model) => ({
		key: model.id,
		value: model.id,
		label: model.description,
	}));
	const brandsOptions = brands.map((brand) => ({ key: brand.id, value: brand.id, label: brand.description }));

	return (
		<Form form={form} className="login-form col-8" layout={'vertical'} data-testid="model-form" preserve={false}>
			<Form.Item name="id" noStyle initialValue={record?.id}>
				<Input hidden={true} />
			</Form.Item>
			<Form.Item
				name="description"
				label={intl.formatMessage(translate('name'))}
				rules={[
					{
						required: true,
						whitespace: true,
						message: intl.formatMessage(translate('nameError')),
					},
				]}
				initialValue={record?.description}
			>
				<Input placeholder={intl.formatMessage(translate('name'))} data-testid="input-name" />
			</Form.Item>
			<Form.Item
				name="modelSendTypeId"
				label={intl.formatMessage(translate('modelSendType'))}
				rules={[
					{
						required: true,
						message: intl.formatMessage(translate('modelSendTypeError')),
					},
				]}
				initialValue={record?.modelSendTypeId || modelSendTypes[0]?.id}
			>
				<Select
					data-testid="select-send"
					showSearch
					filterOption={(input, option) => searchInString(input, option.label)}
					placeholder={intl.formatMessage(translate('modelSendType'))}
					options={modelSendTypeOptions}
				/>
			</Form.Item>
			<Form.Item
				name="brandId"
				label={intl.formatMessage(translate('brand'))}
				rules={[
					{
						required: true,
						message: intl.formatMessage(translate('brandError')),
					},
				]}
				initialValue={record?.brandId || brands[0]?.id}
			>
				<Select
					data-testid="select-brand"
					showSearch
					filterOption={(input, option) => searchInString(input, option.label)}
					placeholder={intl.formatMessage(translate('brand'))}
					options={brandsOptions}
				/>
			</Form.Item>
		</Form>
	);
};

ModelForm.propTypes = {
	form: PropTypes.object,
	record: PropTypes.object,
	brands: PropTypes.array.isRequired,
	modelSendTypes: PropTypes.array.isRequired,
};

export default ModelForm;
